module.exports = __webpack_public_path__ + "img/detail-popup.d93aa59c.png";